import { Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import {
  Dialog, DialogContent, DialogDescription, DialogHeader,
  DialogTitle, DialogFooter,
} from '../ui/dialog';

export function ReviewDialog({
  open, onOpenChange, selectedOrder, editingReview,
  reviewRating, reviewComment, setReviewComment,
  renderStars, setReviewRating, handleSubmitReview, submittingReview,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-surface border-[#262626]">
        <DialogHeader>
          <DialogTitle>{editingReview ? 'Edit Review' : 'Leave a Review'}</DialogTitle>
          <DialogDescription>
            Share your experience with {selectedOrder?.artist_name || 'the artist'}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-6">
          <div>
            <label className="text-sm text-[#A1A1AA] mb-2 block">Rating</label>
            <div className="flex gap-1">
              {renderStars(reviewRating, true, setReviewRating)}
            </div>
          </div>

          <div>
            <label className="text-sm text-[#A1A1AA] mb-2 block">Your Review</label>
            <Textarea
              value={reviewComment}
              onChange={(e) => setReviewComment(e.target.value)}
              placeholder="Tell us about your experience..."
              className="input-dark min-h-[120px]"
              data-testid="review-comment"
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="border-[#262626]">
            Cancel
          </Button>
          <Button
            onClick={handleSubmitReview}
            disabled={submittingReview}
            className="btn-primary"
            data-testid="submit-review-btn"
          >
            {submittingReview ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
            {editingReview ? 'Update Review' : 'Submit Review'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
